import {
    ADMIN_RESET,
    ADMINS_RESET,
    ADMINS_PENDING,
    ADMIN_FOCUS,
    ADMINS_DOWNLOADED,
    ADMIN_DOWNLOADED,
    ADMINS_FAILED,
    ADMIN_FAILED,
    ADMIN_CONFLICT,
    ADMIN_POSTING,
    ADMIN_EDITING,
    ADMIN_DELETING
} from './types';

export const INITIAL_STATE = {
    error: null,
    content: [],
    currentIndex: 0,
    currentAdmin: null,
    pending: false,
    sending: false
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case ADMIN_RESET:
            return {
                ...state,
                error: null,
                sending: false,
                currentIndex: 0,
                currentAdmin: null
            };
        case ADMINS_RESET:
            return INITIAL_STATE;
        case ADMINS_PENDING:
            return {
                ...state,
                pending: true
            };
        case ADMIN_FOCUS:
            return {
                ...state,
                error: null,
                currentIndex: state.content.findIndex(admin => {
                    return admin.id === action.payload.id
                }),
                currentAdmin: action.payload
            };
        case ADMIN_DOWNLOADED:
            let newContent = [];
            let id = action.payload.id;
            let newIndex;
            let admin = state.content.find(function (admin) {
                return admin.id === id
            });

            if (admin) {
                let index = state.content.findIndex(stateAdmin => {
                    return stateAdmin.id === admin.id
                });
                newContent = state.content;
                newContent[index] = action.payload;
                newIndex = index;
            } else {
                newContent = [
                    ...state.content,
                    action.payload
                ];
                newIndex = newContent.length - 1;
            }

            return {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: newContent,
                currentAdmin: action.payload,
                currentIndex: newIndex
            };
        case ADMINS_DOWNLOADED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: action.payload,
                currentIndex: 0,
                currentAdmin: null
            };
        case ADMINS_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload
            };
        case ADMIN_CONFLICT:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload,
                currentAdmin: null,
                currentIndex: 0
            };
        case ADMIN_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload,
                currentAdmin: null,
                currentIndex: 0
            };
        case ADMIN_POSTING:
            return {
                ...state,
                sending: true
            };
        case ADMIN_EDITING:
            return {
                ...state,
                sending: true
            };
        case ADMIN_DELETING:
            return {
                ...state,
                sending: true
            };
        default:
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// src/store/admins/reducers.js